import { invalidateCache } from 'api/urql/helpers/mutation';

export const deletePaymentMethod = (results, args, cache, info) => {
  invalidateCache('requestor')(results, args, cache, info);
};
